/**
 * Input Status Indicator Directive
 * Responsible for setting error status on a custom component
 *
 */
import { Directive } from '@angular/core';

import { BaseInputStatusDirective } from './base-input-status.directive';

@Directive({
  selector: '[tdWbInputStatusIndicator], [tdWbInput]:not(input)',
  host: {
    '[class.td-wb-error]': 'showErrorClass'
  }
})
export class InputStatusIndicatorDirective extends BaseInputStatusDirective {
  showErrorClass: boolean;

  protected onErrorStateChange(): void {
    super.onErrorStateChange();
    this.showErrorClass = this.isErrorState();
  }
}
